// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"533":"81f6d1a5","596":"4e5e1a05","627":"6125b7bf","881":"b000527a"}[chunkId] + ".chunk.js";
};